import React from "react";

import { useParams } from "react-router-dom";
import { MemoryRouter, Route, Switch } from "react-router";

import { ModalPageBackground } from "../../../../organisms/ModalPage";
import PageBg from "../../../../../assets/img/bg/eligibilityCheckerBg.png";
import { LandingPage } from "../../SmokeFree";
import ReadySetGo from "../../ReadySetGo/ReadySetGo";

/**
 * Renders profileBuilder pages
 * @returns SmokeFreeJourney profileBuilder
 */

const SmokeFreeJourney = () => {
  let { programmeSlug } = useParams();

  return (
    <ModalPageBackground className="profile-builder-page" bgImage={PageBg}>
      <MemoryRouter>
        <Switch>
          <Route exact path={"/"} component={LandingPage} />
          <Route path={"/ready-set-go"}>
            <ReadySetGo programmeSlug={programmeSlug} />
          </Route>
        </Switch>
      </MemoryRouter>
    </ModalPageBackground>
  );
};

export default SmokeFreeJourney;
